import React from 'react';

const ShareModal = props => {
  const { onClose, copyBtnLabel, urlToCopy, shareModalCopy, shareModalTitle } =
    props;
  return (
    <div
      className="modal modal--popup"
      id="find-a-community-map-view-row-share-modal"
    >
      <div className="modal__backdrop">
        <div aria-label="" className="modal__container" role="dialog">
          <div className="modal__header ">
            <h2 className="modal__title">{shareModalTitle}</h2>
            <button
              className="modal__close-button"
              aria-label=""
              tabIndex="1"
              onClick={onClose}
            >
              <svg
                width="25px"
                height="25px"
                viewBox="0 0 25 25"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                xmlnsXlink="http://www.w3.org/1999/xlink"
              >
                <g stroke="currentColor" strokeWidth="2">
                  <line x1="0" y1="0" x2="23" y2="23"></line>
                  <line x1="23" y1="0" x2="6.38378239e-16" y2="23"></line>
                </g>
              </svg>
            </button>
          </div>
          <div className="modal__content">
            <form className="share-popup">
              <div className="share-popup__copy rtf">{shareModalCopy}</div>
              <div className="share-popup__fields">
                <input
                  className="field__input share-popup__input find-a-community-map-view-row__modal-copy-url"
                  aria-label="share url"
                  readOnly=""
                  value={urlToCopy}
                  tabIndex="1"
                />

                <button
                  className="btn btn--submit find-a-community-map-view-row__modal-copy-btn"
                  type="button"
                  tabIndex="1"
                  onClick={() => {
                    const copyText = document.querySelector(
                      '.find-a-community-map-view-row__modal-copy-url'
                    );
                    copyText.select();
                    copyText.setSelectionRange(0, 99999);
                    document.execCommand('copy');
                    const feedback = document.querySelector(
                      '.find-a-community-map-view-row__modal-copy-feedback'
                    );
                    feedback.innerHTML = 'Copied!';
                    setTimeout(() => {
                      feedback.innerHTML = '';
                    }, 3000);
                  }}
                >
                  <span className="btn__label">{copyBtnLabel}</span>
                </button>
              </div>
              <div className="share-popup__feedback find-a-community-map-view-row__modal-copy-feedback"></div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShareModal;
